/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AntennaACreate
 */
export interface AntennaACreate {
    /**
     * 
     * @type {string}
     * @memberof AntennaACreate
     */
    eloshieldConfigurationId: string;
    /**
     * 
     * @type {number}
     * @memberof AntennaACreate
     */
    antennaIndex: number;
    /**
     * Height in decimeter.
     * @type {number}
     * @memberof AntennaACreate
     */
    heightDm: number;
    /**
     * 
     * @type {number}
     * @memberof AntennaACreate
     */
    zone1RadiusCm: number;
    /**
     * 
     * @type {number}
     * @memberof AntennaACreate
     */
    zone2RadiusCm: number;
    /**
     * 
     * @type {number}
     * @memberof AntennaACreate
     */
    mutingDistanceCm: number;
}

/**
 * Check if a given object implements the AntennaACreate interface.
 */
export function instanceOfAntennaACreate(value: object): value is AntennaACreate {
    if (!('eloshieldConfigurationId' in value) || value['eloshieldConfigurationId'] === undefined) return false;
    if (!('antennaIndex' in value) || value['antennaIndex'] === undefined) return false;
    if (!('heightDm' in value) || value['heightDm'] === undefined) return false;
    if (!('zone1RadiusCm' in value) || value['zone1RadiusCm'] === undefined) return false;
    if (!('zone2RadiusCm' in value) || value['zone2RadiusCm'] === undefined) return false;
    if (!('mutingDistanceCm' in value) || value['mutingDistanceCm'] === undefined) return false;
    return true;
}

export function AntennaACreateFromJSON(json: any): AntennaACreate {
    return AntennaACreateFromJSONTyped(json, false);
}

export function AntennaACreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AntennaACreate {
    if (json == null) {
        return json;
    }
    return {
        
        'eloshieldConfigurationId': json['eloshieldConfigurationId'],
        'antennaIndex': json['antennaIndex'],
        'heightDm': json['heightDm'],
        'zone1RadiusCm': json['zone1RadiusCm'],
        'zone2RadiusCm': json['zone2RadiusCm'],
        'mutingDistanceCm': json['mutingDistanceCm'],
    };
}

export function AntennaACreateToJSON(json: any): AntennaACreate {
    return AntennaACreateToJSONTyped(json, false);
}

export function AntennaACreateToJSONTyped(value?: AntennaACreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eloshieldConfigurationId': value['eloshieldConfigurationId'],
        'antennaIndex': value['antennaIndex'],
        'heightDm': value['heightDm'],
        'zone1RadiusCm': value['zone1RadiusCm'],
        'zone2RadiusCm': value['zone2RadiusCm'],
        'mutingDistanceCm': value['mutingDistanceCm'],
    };
}

